<template>
  <div>
    <v-dialog persistent :value="threshholdModal" width="500">
      <v-card>
        <v-card-title>Set inventory threshold</v-card-title>
        <v-card-text>
          <div>
            <v-text-field
              min="0"
              type="number"
              label="Min*"
              v-model.number="threshhold"
              @keydown="preventMinus"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="closeModal()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            style="text-transform: capitalize;"
            >Cancel</v-btn
          >
          <v-btn
            @click="updateData()"
            color="white"
            :class="
              $vuetify.breakpoint.width > 960
                ? 'ml-0 mr-0 primary'
                : 'ml-0 primary'
            "
            style="text-transform: capitalize;"
            >SET</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import Helper from '@/utility/Helpers'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
// import _ from 'lodash'

export default {
  data() {
    return {
      normalValidation: [v => !!v || 'Field is required'],
      threshhold: 0
    }
  },
  computed: {
    ...mapGetters({
      threshholdModal: 'locationcategory/threshholdPop',
      threshholdObj: 'locationcategory/threshholdObj'
    })
  },
  watch: {
    threshholdModal(val) {
      if (val === true) {
        this.threshhold = this.threshholdObj.inventory_threshold
      }
    }
  },
  mounted() {
    this.closeModal()
    this.spinner(false)
  },
  methods: {
    preventMinus(e) {
      if (e.keyCode === 189 || e.keyCode === 109 || e.keyCode === 173) {
        e.preventDefault()
        return false
      }
    },
    /**
     * Update
     */
    async updateData() {
      try {
        // Trigger apis
        this.spinner(true)
        let result = await LocationCategoryAPI.setInventoryThreshold({
          categoryId: this.threshholdObj.id,
          inventoryThreshold: this.threshhold
        })
        this.spinner(false)
        if (result.status === 200) {
          this.closeModal()
        }
        // Display message alert
        this.snackbar({
          text:
            result.status === 200
              ? result.data.msg
              : result.response.data.errors
              ? result.response.data.errors[0]
              : result.response.data.msg,
          open: true,
          color: result.status === 200 ? 'success' : 'error'
        })
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors
            ? err.response.data.errors[0]
            : err.response.data.message,
          open: true,
          color: 'error'
        })

        this.closeModal()
      }
    },

    /**
     * Close modal
     */
    closeModal() {
      this.setThreshholdPop(false)
      this.setThreshholdObj({})
    },

    ...mapActions({
      setThreshholdPop: 'locationcategory/setThreshholdPop',
      setThreshholdObj: 'locationcategory/setThreshholdObj'
    })
  }
}
</script>
